var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "textarea",
        ..._vm.variantClassList,
        _vm.hasError && "has-error",
        _vm.sizeIconErrorFeature && "has-icon-error-feature",
        _vm.disabled && "is-disabled"
      ],
      attrs: { disabled: _vm.disabled }
    },
    [
      _vm.labelText
        ? _c("Label", {
            staticClass: "textarea__label",
            attrs: { labelText: _vm.labelText, forElementId: _vm.uid },
            scopedSlots: _vm._u(
              [
                {
                  key: "leading",
                  fn: function() {
                    return [_vm._t("beforeLabel")]
                  },
                  proxy: true
                },
                {
                  key: "trailing",
                  fn: function() {
                    return [_vm._t("afterLabel")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "textarea__body", style: [_vm.textAreaWidthStyle] },
        [
          _c("div", { staticClass: "textarea__field-container" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue"
                }
              ],
              ref: "input",
              staticClass: "textarea__field",
              attrs: {
                placeholder: _vm.placeholder,
                "aria-label": _vm.ariaLabel,
                rows: _vm.rows
              },
              domProps: { value: _vm.currentValue },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  },
                  _vm.inputSearchText
                ],
                change: _vm.updateSearchText,
                blur: _vm.blurSearchText,
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  )
                    return null
                  _vm.withFocus = true
                },
                keyup: _vm.onKeyUp,
                click: _vm.onClick,
                focus: _vm.onInputFocus
              }
            })
          ]),
          _vm.hasCounter
            ? _c("span", { staticClass: "textarea__word-count" }, [
                _vm._v(
                  " " +
                    _vm._s((_vm.currentValue && _vm.currentValue.length) || 0) +
                    "/" +
                    _vm._s(_vm.maxLength) +
                    " "
                )
              ])
            : _vm._e()
        ]
      ),
      _vm.helpText
        ? _c("HelpFeedback", {
            staticClass: "textarea__help-feedback",
            style: [_vm.textAreaWidthStyle],
            attrs: { helpText: _vm.helpText }
          })
        : _vm._e(),
      _vm.hasError
        ? _c("ErrorFeedback", {
            staticClass: "textarea__error-feedback",
            attrs: { errorMessages: _vm.errorMessages }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }